import { onMounted, nextTick, reactive, ref, computed } from "vue";
import { WOW } from "wowjs";
import "animate.css";
import { reqSendUserMsg } from "@/api";
import { useContactStore } from "@/store/contact"; //引入news仓库

import { storeToRefs } from "pinia"; //引入方法让仓库里的值可以解构赋值并且具有响应式

import { ElMessage } from "element-plus";
import "element-plus/dist/index.css";
export default {
  name: "Contact",
  setup: function setup() {
    var store = useContactStore();
    onMounted(function () {
      // if (!token.value) {
      //   store.getToken() //获取token
      // }
      //初始化wow.js(页面滚动加载动画)
      nextTick(function () {
        //页面渲染完，在执行
        var wow = new WOW({
          live: false
        });
        wow.init();
      });
    }); //数据

    var _storeToRefs = storeToRefs(store),
        success = _storeToRefs.success; //从仓库获取请求状态码


    var token = computed(function () {
      return localStorage.getItem("token");
    }); //从本地获取token

    var email = ref("");
    var UserMsg = reactive({
      //收集表单的数据
      company_name: "",
      //公司名
      link_man: "",
      //联系人姓名
      link_mobile: "",
      //联系电话
      sale: 39,
      //绑定的销售
      details: [{
        types: 5,
        special_needs: "",
        // 留言
        needs_num: 1
      }]
    }); //方法
    //提交用户数据

    function sendMsg() {
      if (UserMsg.link_man && UserMsg.link_mobile && UserMsg.company_name) {
        //输入的name和phone不为空
        var headers = {
          //设置请求头，携带token
          Authorization: "Bearer " + token.value //根据服务端设置token(这里后端需要在Bearer后加上空格|不能删除)

        };

        if (UserMsg.details[0].special_needs == "") {
          //因为公司名是必填的参数，不填写会导致请求发送失败所以当该值为空时设置为默认值
          UserMsg.details[0].special_needs = " "; //设置默认值为" "
        }

        store.sendUserMsg(UserMsg, headers); //发送请求并携带用户数据和token

        setTimeout(function () {
          if (success.value == 1) {
            //成功发送用户数据时，弹框提示成功 / type:success
            ElMessage({
              message: "提交成功",
              type: "success",
              center: true
            });
          } else if (success.value == 2) {
            //未成功发送用户数据时
            ElMessage({
              message: "提交失败,请刷新页面再次提交。",
              type: "error",
              center: true
            });
          }
        }, 100);
      } else {
        if (!UserMsg.link_man && UserMsg.link_mobile && UserMsg.company_name) {
          //输入的 link_man 为空时，弹框提示
          ElMessage({
            message: "您的姓名，不能为空",
            type: "warning",
            center: true
          });
        } else if (UserMsg.link_man && !UserMsg.link_mobile && UserMsg.company_name) {
          //输入的 link_mobile 为空时，弹框提示
          ElMessage({
            message: "联系电话，不能为空",
            type: "warning",
            center: true
          });
        } else if (UserMsg.link_man && UserMsg.link_mobile && !UserMsg.company_name) {
          //输入的 company_name 为空时，弹框提示
          ElMessage({
            message: "您的公司，不能为空",
            type: "warning",
            center: true
          });
        } else if (!UserMsg.link_man && !UserMsg.link_mobile && UserMsg.company_name) {
          //输入的 link_man 和 link_mobile 为空时，弹框提示
          ElMessage({
            message: "您的姓名、联系电话，不能为空",
            type: "warning",
            center: true
          });
        } else if (!UserMsg.link_man && UserMsg.link_mobile && !UserMsg.company_name) {
          //输入的 link_man 和 company_name 为空时，弹框提示
          ElMessage({
            message: "您的姓名、您的公司，不能为空",
            type: "warning",
            center: true
          });
        } else if (UserMsg.link_man && !UserMsg.link_mobile && !UserMsg.company_name) {
          //输入的 link_man 和 company_name 为空时，弹框提示
          ElMessage({
            message: "联系电话、您的公司，不能为空",
            type: "warning",
            center: true
          });
        } else {
          //输入的 link_man 和 link_mobile 和 company_name 为空时，弹框提示
          ElMessage({
            message: "您的姓名、联系电话、您的公司，不能为空",
            type: "warning",
            center: true
          });
        }
      }
    }

    return {
      email: email,
      UserMsg: UserMsg,
      sendMsg: sendMsg
    };
  }
};